import React from "react";
import { LocaleProvider } from "@insightfulscience/smart-react/i18";

import createClient from "../../createClient";
import ResourcesPage from "./Page";
import mapFeaturedBlock from "../components/FeaturedContentBlock/mapper";
import locales from "../../locales";

const contentfulResourcesFactory = ({ Layout, contentfulProps, pageProps }) => {
	const ContentfulResourcesPage = ({ page }) => {
		const { brandCode, resources = null } = pageProps;

		return (
			<Layout>
				<LocaleProvider resources={resources || locales[brandCode]}>
					<ResourcesPage page={page} pageProps={pageProps} />
				</LocaleProvider>
			</Layout>
		);
	};

	ContentfulResourcesPage.getInitialProps = async () => {
		const client = createClient(contentfulProps);
		const { filter = {} } = contentfulProps;
		const blockFeaturedContent = await client.getEntries({
			content_type: "blockFeaturedContent",
			...filter,
		});

		return { page: { sections: mapFeaturedBlock(blockFeaturedContent) } };
	};

	ContentfulResourcesPage.propTypes = {
		...ResourcesPage.propTypes,
	};

	return ContentfulResourcesPage;
};

export default contentfulResourcesFactory;
